import React, { Component } from "react";
import client from "@culturehq/client";
import { Form, PasswordField, SubmitButton, Success } from "@culturehq/components";

import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import PasswordChecklist, { PasswordValidator } from "components/common/PasswordChecklist";
import PageHeader from "components/display/PageHeader";

const ARIA_VALIDATION_DELAY = 1000;

const ChangePasswordForm = props => {
  const {
    onSubmit,
    submitDisabled,
    validator,
    onPasswordChange,
    onConfirmationChange
  } = props;

  return (
    <Form onSubmit={onSubmit}>
      <PasswordField name="oldPassword" required>
        <Trans>Old Password</Trans>
      </PasswordField>
      <PasswordField name="newPassword" onChange={onPasswordChange} required>
        <Trans>New Password</Trans>
      </PasswordField>
      <PasswordField name="passwordConfirmation" onChange={onConfirmationChange} required>
        <Trans>Confirm Password</Trans>
      </PasswordField>
      <PasswordChecklist validator={validator} />
      <SubmitButton disabled={submitDisabled} primary>
        {submitting => (submitting ? t("Updating...") : t("Change Password"))}
      </SubmitButton>
    </Form>
  );
};

class ChangePassword extends Component {
  state = {
    error: false,
    success: false,
    validator: new PasswordValidator()
  };

  timeout = 0;

  performValidation = () => {
    this.setState(({ validator }) => ({
      error: validator.isValid() ? false : validator.getError()
    }));
  };

  performConfirmationValidation = () => {
    this.setState(({ validator }) => ({
      error: validator.matches() ? false : t("The passwords are not matching")
    }));
  };

  handlePasswordChange = password => {
    this.setState(({ validator }) => ({
      validator: validator.mutate({ password })
    }));

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => this.performValidation(), ARIA_VALIDATION_DELAY);
  };

  handleConfirmationChange = confirmation => {
    this.setState(({ validator }) => ({
      validator: validator.mutate({ confirmation })
    }));

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => this.performConfirmationValidation(), ARIA_VALIDATION_DELAY);
  };

  handleSubmit = async ({ oldPassword, newPassword }) => {
    this.setState({ success: false, error: false });

    try {
      await client.changePassword({ oldPassword, newPassword });
      this.setState({ success: true });
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    const { error, success, validator, ariaValidation } = this.state;

    return (
      <div className="change-password">
        <PageHeader title={t("Change your Password")}>
          <Trans>Confirm your current password, and re-enter a new password.</Trans>
        </PageHeader>

        {!success && (
          <ChangePasswordForm
            onSubmit={this.handleSubmit}
            submitDisabled={!validator.isValid()}
            validator={validator}
            onPasswordChange={this.handlePasswordChange}
            onConfirmationChange={this.handleConfirmationChange}
          />
        )}
        {error && <ErrorMessage error={error} />}
        {success && <Success><Trans>Password Updated</Trans></Success>}
      </div>
    );
  }
}

export default ChangePassword;
